<template>
    <div>
        <div class="font-sans text-gray-800 bg-white w-full md:p-0 py-20">
            <div class="md:h-[50vh] md:flex items-center p-4 md:p-0 md:w-[900px] mx-auto mb-10 md:mb-0">
                <div class="md:flex items-center justify-between gap-4 mx-auto">
                    <div class="md:mb-8 text-center">
                        <h2 class="text-6xl font-bold text-slate-800">Réinventez vos</h2>
                        <h2 class="text-6xl font-bold text-orange-600">annonces immobilières</h2>
                        <h4 class="text-3xl font-thin mt-4 text-slate-600">Aujourd'hui, nous avons besoin de votre avis sur <br /> ce nouveau projet</h4>
                    </div>
                </div>
            </div>
            
            <div class="md:w-[900px] mx-auto text-slate-700 p-4 md:p-0 text-xl md:text-base">
                <div>
                    <div>
                        <section class="mb-8">
                            <div class="md:p-10">
                                <div class="mx-auto">
                                    <h3 class="text-4xl font-light mb-4 text-slate-700">Une expérience numérique dépassée : <div class="underline font-bold">Frustrante, Complexe et Inefficace</div></h3>
                                    <p class="mb-4 font-light text-2xl mt-20">
                                        Depuis leur arrivée, les visites virtuelles ont apporté un souffle d’innovation à l’immobilier. Mais soyons réalistes : elles sont loin d’être parfaites.
                                    </p>
                                </div>
                                <div class="md:grid grid-cols-2 my-20 items-center gap-10">
                                    <img class="w-full rounded" src="https://i.ibb.co/SyFGhtV/Enregistrement-de-l-e-cran-2024-12-06-a-12-52-45.gif" alt="">
                                    <div>
                                        <div class="mt-4 md:mt-0 text-xl font-light text-center bg-orange-100 border-2 border-orange-300 text-orange-600 rounded p-4">Après <b class="font-bold">19 clicks</b> nous avons à peine visiter une pièce</div>
                                        <img class="h-[100px] opacity-60 -mt-0.5 hidden md:block" src="https://i.ibb.co/3msMy7B/Nouveau-projet-81.png" alt="">
                                    </div>
                                </div>
                                <ul class="space-y-10">
                                    <li class="font-light text-lg"><div class="font-bold text-xl"><i class="fas fa-times mr-1"></i> Trop d’efforts pour une simple visite</div> Une visite virtuelle exige un effort considérable de l'utilisateur, rendant l'exploration du bien laborieuse.</li>
                                    <li class="font-light text-lg"><div class="font-bold text-xl"><i class="fas fa-times mr-1"></i> Agencement difficile à comprendre</div> Sans une vue d’ensemble claire, il est compliqué de comprendre l’agencement du bien.</li>
                                    <li class="font-light text-lg"><div class="font-bold text-xl"><i class="fas fa-times mr-1"></i> Inadaptées aux grands biens</div> Dans une grande propriété ou un bien complexe, il est difficile de s’orienter avec des visites 360°.</li>
                                    <li class="font-light text-lg"><div class="font-bold text-xl"><i class="fas fa-times mr-1"></i> Peu inclusives</div> Tous vos prospects ne sont pas des experts en numérique. Beaucoup abandonnent dès les premières étapes, incapables de naviguer correctement.</li>
                                    <li class="font-light text-lg"><div class="font-bold text-xl"><i class="fas fa-times mr-1"></i> Coût élevé</div> Les caméras spécialisées et les solutions complexes alourdissent vos dépenses.</li>
                                </ul>
                            </div>
                        </section>
                    </div>
                </div>
                
                <div>
                    <div>
                        <div class="my-20 text-center">
                            <p class="text-5xl font-bold text-orange-600" style="line-height: 70px;">
                                Ces limites appartiennent désormais au passé
                            </p>
                        </div>
                        
                        <section class="mb-8 mt-10 md:bg-orange-50 rounded-3xl md:p-4">
                            <div class="md:p-10">
                                <h3 class="text-3xl font-light mb-1">Une nouvelle expérience accessible à tous</h3>
                                <p class="text-4xl font-bold mb-4 text-slate-700">Redonnons aux visites virtuelles leur véritable objectif</p>
                                <p class="mb-4 font-light">
                                    Simplifier et enrichir la découverte d’un bien immobilier. Finit les frustrations des outils classiques, et place à une navigation intuitive
                                    et engageante.
                                </p>
                                <h4 class="text-3xl my-10">Notre idée ? Visiter un bien grâce à un plan interactif</h4>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-10 my-10 items-center">
                                    <div class="order-last md:order-first">
                                        <ul class="space-y-8">
                                            <li class="font-light"><div class="font-bold text-lg"><i class="fas fa-check mr-1"></i> Visualisation du plan</div> Vos prospects voient d’un coup d’œil la disposition des pièces et des espaces.</li>
                                            <li class="font-light"><div class="font-bold text-lg"><i class="fas fa-check mr-1"></i> Cliquez sur une pièce</div> En un clic sur une pièce, ils accèdent à toutes les informations de celle-ci (photos, vidéos, descriptions, ...).</li>
                                            <li class="font-light"><div class="font-bold text-lg"><i class="fas fa-check mr-1"></i> Une navigation simple et rapide</div> Plus besoin de manipuler des vues complexes ou de "se déplacer" virtuellement.</li>
                                        </ul>
                                    </div>
                                    <div >
                                        <img class="w-full" src="https://i.ibb.co/Z292xh8/Capture-d-e-cran-2024-12-14-a-13-31-40.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

                <!-- <div class="text-center my-28 sticky top-0 left-0 right-0 py-2 bg-white/90">
                    <button class="px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded shadow-lg"><i class="fas fa-arrow-pointer mr-2"></i> Accéder à la démonstration en ligne</button>
                </div> -->

                <!-- <div class="flex justify-between">
                    <img class="h-[150px] -mt-1 scale-x-[-1] opacity-30" src="https://i.ibb.co/3msMy7B/Nouveau-projet-81.png" alt="">
                    <img class="h-[150px] -mt-1 opacity-30 hidden md:block" src="https://i.ibb.co/3msMy7B/Nouveau-projet-81.png" alt="">
                </div>
                <div class="h-[20vh] flex items-center flex-col gap-4 mt-4 md:-mt-16">
                    <h2 class="text-4xl mb-2 font-bold">Démonstration en ligne</h2>
                    <a href="/demo" target="_blank" class="px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded shadow-lg shadow-slate-300"><i class="fas fa-arrow-pointer mr-2"></i> Accéder à la démonstration en ligne</a>
                </div> -->

                
                <div>
                    <div>
                        <div class="my-20">
                            <p class="text-5xl font-bold text-orange-600" style="line-height: 70px;">Découvrez pourquoi notre solution sera bénéfique pour votre entreprise</p>
                        </div>

                        <section class="mb-8 mt-10">
                            <div>
                                <h3 class="text-4xl font-bold mb-4 text-slate-700 mb-20">Un outil indispensable dans votre business</h3>
                                <div class="grid md:grid-cols-2 gap-10">
                                    <div class="mb-6">
                                        <h4 class="text-2xl mb-2 font-bold text-orange-600">Retour sur investissement imbattable</h4>
                                        <p class="text-lg font-light">
                                            Vous pourriez éviter jusqu’à 5 visites inutiles par mois, économisant environ 150 € en temps (5 heures à 30 €/heure) + les frais de déplacement. Nos estimations montrent également une possible hausse d’au moins 15 % des conversions, ce qui pourrait représenter une vente supplémentaire (5 000 € de commission) tous les 6 mois, pour seulement 25 €/mois. Cela équivaut à un ROI minimum de 2 900 %, faisant de ce projet un investissement sûr et stratégique.
                                        </p>
                                    </div>
                                    <div class="mb-6">
                                        <h4 class="text-2xl mb-2 font-bold text-orange-600">Des mandats exclusifs</h4>
                                        <p class="text-lg font-light">
                                            Démarquez-vous en tant qu’agent immobilier moderne et efficace. Offrez à vos clients vendeurs une présentation interactive qui valorise leurs biens et inspire confiance, augmentant vos chances de décrocher des mandats exclusifs. Cet outil innovant renforce votre image de professionnel à la pointe, tout en répondant aux attentes des acheteurs pour une expérience claire et haut de gamme.
                                        </p>
                                    </div>
                                    <div class="mb-6">
                                        <h4 class="text-2xl mb-2 font-bold text-orange-600">Rapide, simple et accessible à tous</h4>
                                        <p class="text-lg font-light">
                                            Avec ce projet, créez une visite interactive en moins de 10 minutes, sans besoin de compétences techniques. Notre outil intuitif vous guide étape par étape, avec une interface simple et des tutoriels clairs. Un outil rapide, efficace et accessible à tous.
                                        </p>
                                    </div>
                                    <div class="mb-6">
                                        <h4 class="text-2xl mb-2 font-bold text-orange-600">Intégration facile</h4>
                                        <p class="text-lg font-light">
                                            Ajoutez une visite interactive à vos annonces en un clin d'œil. Partagez un lien, intégrez une iframe, ou utilisez notre API pour une solution avancée. Le partage d'une visite ne demande aucune compétence technique.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

                <div class="py-2 text-center">
                    <div>Etape suivante</div>
                    <div class="mt-2"><i class="fas fa-arrow-down"></i></div>
                </div>
                <div class="fixed bottom-0 left-0 right-0 py-5 bg-white/50 backdrop-blur-lg">
                    <div class="md:w-[900px] mx-auto flex justify-center gap-4">
                        <button @click="$router.push({name: 'demo'})" class="bg-orange-600 hover:bg-orange-700 duration-200 text-white font-bold text-lg px-8 py-2 rounded-full">
                            Accéder à la démonstration
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import axios from 'axios'
export default {
    async mounted () {

        if (location.hostname !== "localhost" && location.hostname !== "127.0.0.1") {
            let token = localStorage.getItem('token')
            if (!token) {
                let makeid = (length) => {
                    let result = '';
                    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                    const charactersLength = characters.length;
                    let counter = 0;
                    while (counter < length) {
                        result += characters.charAt(Math.floor(Math.random() * charactersLength));
                        counter += 1;
                    }
                    return result;
                }
                token = makeid(10)
                localStorage.setItem('token', token)
            }
            axios.post('https://x8ki-letl-twmt.n7.xano.io/api:0NC1WJQ2/views', {
                token: token,
                page: 'presentation'
            })
        }
    },
}
</script>

<style>
.parent {
  position: relative;
}

.gradient-shadow {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
  bottom: -0.5rem;
  left: -0.5rem;
  background: linear-gradient(to right, #ca8a04, #ea580c, #dc2626);
  border-radius: 0.5rem;
  opacity: 0.8;
  filter: blur(20px);
}

.content {
  position: relative;
}


</style>
